export { default } from './Accordion';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/Accordion/index.js
// module id = 782
// module chunks = 121